import { render, staticRenderFns } from "./OktaFactorSettings.vue?vue&type=template&id=709c0cd4&scoped=true"
import script from "./OktaFactorSettings.vue?vue&type=script&lang=ts"
export * from "./OktaFactorSettings.vue?vue&type=script&lang=ts"
import style0 from "./OktaFactorSettings.vue?vue&type=style&index=0&id=709c0cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709c0cd4",
  null
  
)

export default component.exports